export default __webpack_public_path__ + "static/media/TopBarCamera.958a4da6.svg";